import type Enum from "../entities/enum";

export default function (country?: Enum): string {
  if (country) {
    return `${country?.code} - ${country?.name}`;
  }

  return "";
}
